module.exports = __webpack_public_path__ + "static/media/fg-desk.51529f43.svg";